export const SocialLinks = [
    {platform: "facebook", link: "https://www.facebook.com/profile.php?id=100087644260703"},
    {platform: "instagram", link: "https://www.instagram.com/sun_shineapp/"},
    {platform: "tiktok", link: "https://www.tiktok.com/@the_sunshineapp?lang=en"},
    {platform: "twitter", link: "https://twitter.com/SunShineApp_"},
    {platform: "youtube", link: "https://www.youtube.com/channel/UCwA1j9ByldoGS3MFvPU6Qhg"},
];